module.exports = __webpack_public_path__ + "img/app-mobile-image-2.680fdbe5.png";